type TermsLabelProps = {
  isProfessional: boolean;
};

export const TermsLabel = ({ isProfessional }: TermsLabelProps) => {
  return (
    <p>
      J&apos;ai lu et j&apos;accepte les{" "}
      <a href="/cgu" className="text-blue-400 underline" target="_blank">
        conditions générales d&apos;utilisation
      </a>
      {isProfessional && (
        <>
          {", "}
          <a
            href="https://professionnels.connect-events.fr/conditions-d-acces-pro"
            target="_blank"
            rel="noreferrer"
            className="text-blue-400 underline"
          >
            les conditions d&apos;accès pro
          </a>
        </>
      )}{" "}
      et j&apos;ai pris connaissance de la{" "}
      <a
        className="text-blue-400 underline"
        href={
          isProfessional
            ? "https://professionnels.connect-events.fr/politique-de-confidentialite"
            : "/politique-de-confidentialite"
        }
        target="_blank"
        rel="noreferrer"
      >
        politique de confidentialité
      </a>
    </p>
  );
};
